import { hookstate } from '@hookstate/core'

const globalCertificationQuestionStore = hookstate({
});

export default globalCertificationQuestionStore;